import { NgModule } from '@angular/core';
import { checkoutB2BTranslationChunksConfig, checkoutB2BTranslationsEn } from '@spartacus/checkout/b2b/assets';
import { checkoutTranslationChunksConfig, checkoutTranslationsEn } from '@spartacus/checkout/base/assets';
import { CheckoutStepService } from '@spartacus/checkout/base/components';
import { CHECKOUT_FEATURE } from '@spartacus/checkout/base/root';
import {
  checkoutScheduledReplenishmentTranslationChunksConfig,
  checkoutScheduledReplenishmentTranslationsEn,
} from '@spartacus/checkout/scheduled-replenishment/assets';
import { CheckoutScheduledReplenishmentRootModule } from '@spartacus/checkout/scheduled-replenishment/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { CustomCheckoutStepService } from './base/components/services/checkout-step.service';
import { CheckoutRootModule } from './base/root/checkout-root.module';
import { CheckoutB2BRootModule } from './b2b/root/checkout-b2b-root.module';
import { CheckoutPreviewShippingAddressModule } from './base/components/checkout-preview-shipping-address/checkout-preview-shipping-address.module';

@NgModule({
  declarations: [],
  imports: [
    CheckoutRootModule,
    CheckoutB2BRootModule,
    CheckoutScheduledReplenishmentRootModule,
    CheckoutPreviewShippingAddressModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [CHECKOUT_FEATURE]: {
          module: () => import('./checkout-wrapper.module').then(m => m.CheckoutWrapperModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutTranslationsEn },
        chunks: checkoutTranslationChunksConfig,
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutB2BTranslationsEn },
        chunks: checkoutB2BTranslationChunksConfig,
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: checkoutScheduledReplenishmentTranslationsEn },
        chunks: checkoutScheduledReplenishmentTranslationChunksConfig,
      },
    }),
    {
      provide: CheckoutStepService,
      useClass: CustomCheckoutStepService,
    },
  ],
})
export class CheckoutFeatureModule {}
